// extracted by mini-css-extract-plugin
export default {"recaptchaLink":"RecaptchaDescription_recaptchaLink__p3GkW","recaptchaDescription":"RecaptchaDescription_recaptchaDescription__AgKsM"};